import {
  LayoutDashboard,
  Building2,
  Package,
  ClipboardList,
  Globe2,
  MapPinned,
  HandCoins,
  Users,
  IdCard,
  Receipt,
  FileBarChart,
  LineChart,
  Handshake,
  FileSignature,
  Share2,
  Link2,
  LayoutTemplate,
  Building,
  CreditCard,
  MessageCircle,
  AlertTriangle,
  RotateCcw,
  Banknote,
  Navigation,
  MapPin,
  Truck,
  UserRound,
  Route,
  PieChart,
  Wallet,
  Layers,
  FileText,
  Lightbulb,
  User,
  Store,
  Clock,
  LogIn,
  ArrowUpRight,
  ArrowDownLeft,
  UserPlus,
  Search,
  Inbox,
  Star,
  Mail,
  Circle,
  BookOpen,
  Shuffle,
  IndianRupee,
  Settings,
  PackageCheck,
  ShieldCheck,
} from 'lucide-react';

export const SIDEBAR_ICONS = {
  'sidebar.dashboard': LayoutDashboard,
  'sidebar.companyManagement': Building2,
  'sidebar.companyProfile': Building,
  'sidebar.companySubscription': CreditCard,
  'sidebar.whatsappCounter': MessageCircle,
  'sidebar.gstVerificationCounter': ShieldCheck,
  'sidebar.shipments': Package,
  'sidebar.shipment': Package,
  'sidebar.updateStatus': PackageCheck,
  'sidebar.shipmentPayment': CreditCard,
  'sidebar.shipmentCrossing': Shuffle,
  'sidebar.shipmentMissing': AlertTriangle,
  'sidebar.shipmentReturn': RotateCcw,
  'sidebar.dailyEarnings': Banknote,
  'sidebar.trackShipment': Navigation,
  'sidebar.masterLoadingSheet': ClipboardList,
  'sidebar.mlSheetsList': ClipboardList,
  'sidebar.ogclTransferRequests': Truck,
  'sidebar.settleWithCompany': Wallet,
  'sidebar.settlementApprovals': Inbox,
  'sidebar.recordAgentSettlement': HandCoins,
  'sidebar.returnToCompany': Wallet,
  'sidebar.settlements': HandCoins,
  'sidebar.mlSettlementApprovals': Inbox,
  'sidebar.paidAmountSettlement': Banknote,
  'sidebar.paidSettlementApprovals': Banknote,
  'sidebar.agentCommissionPayments': Wallet,
  'sidebar.externalMLSheet': Globe2,
  'sidebar.locationHubVehicle': MapPinned,
  'sidebar.locationHubs': MapPin,
  'sidebar.vehicle': Truck,
  'sidebar.vehicleOwner': UserRound,
  'sidebar.routes': Route,
  'sidebar.shipmentCommission': HandCoins,
  'sidebar.commissionDashboard': PieChart,
  'sidebar.partnerPayout': Wallet,
  'sidebar.bulkPayment': Layers,
  'sidebar.partySettlementRequests': Inbox,
  'sidebar.submitSettlementPayment': CreditCard,
  'sidebar.mySettlementRequests': FileText,
  'sidebar.settlementPayments': HandCoins,
  'sidebar.commissionParties': Users,
  'sidebar.commissionRecord': FileText,
  'sidebar.agentBulkSettlement': Banknote,
  'sidebar.hubInsights': Lightbulb,
  'sidebar.userManagement': Users,
  'sidebar.users': User,
  'sidebar.clientsVendors': Store,
  'sidebar.hrWorkforce': IdCard,
  'sidebar.attendance': Clock,
  'sidebar.bulkLoginLogout': LogIn,
  'sidebar.salaryPayroll': Wallet,
  'sidebar.expenseManagement': IndianRupee,
  'sidebar.companySettings': Settings,
  'sidebar.cashbook': BookOpen,
  'sidebar.expenses': IndianRupee,
  'sidebar.loans': ArrowUpRight,
  'sidebar.loansReceived': ArrowDownLeft,
  'sidebar.misReports': FileBarChart,
  'sidebar.analyticalReports': LineChart,
  'sidebar.onContract': Handshake,
  'sidebar.contractManagement': FileSignature,
  'sidebar.contractParty': Users,
  'sidebar.vehicleContract': Truck,
  'sidebar.agentNetwork': Share2,
  'sidebar.partnerAgents': UserPlus,
  'sidebar.findAgent': Search,
  'sidebar.requests': Inbox,
  'sidebar.myPartnerships': Link2,
  'sidebar.contentManagement': LayoutTemplate,
  'sidebar.testimonials': Star,
  'sidebar.contactMessages': Mail,
};

export const NavIcon = ({ labelKey, size = 'md', active = false }) => {
  const Icon = SIDEBAR_ICONS[labelKey] || Circle;
  const isSmall = size === 'sm';
  const iconSize = isSmall ? 'w-3.5 h-3.5' : 'w-[18px] h-[18px]';

  if (isSmall) {
    return (
      <span
        className={`flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-md transition-colors ${
          active ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'
        }`}
      >
        <Icon className={iconSize} strokeWidth={1.75} />
      </span>
    );
  }

  return (
    <span
      className={`flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg transition-all duration-200 ${
        active
          ? 'bg-blue-600 text-white shadow-sm shadow-blue-600/25'
          : 'bg-gray-100 text-gray-500 group-hover:bg-gray-200 group-hover:text-gray-700'
      }`}
    >
      <Icon className={iconSize} strokeWidth={1.75} />
    </span>
  );
};
